import React, { useEffect, useState } from 'react';
import '../../css/Products/SideBarCategories.css';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { SpinningCircles } from 'react-loading-icons';

const SidebarCategories = ({ onCategoryClick }) => {
  const [categories, setCategories] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);
  const navigate = useNavigate();
  const { category: activeCategory, subcategory: activeSubcategory } = useParams();

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API}/wcategories`);
        setCategories(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchCategories();
  }, []);

  const toggleCategory = (name) => {
    setOpenCategory(prev => (prev === name ? null : name));
  };

  if (!categories) {
    return <SpinningCircles />;
  }

  return (
    <aside className="sidebar-categories">
      <h3>Kategóriák</h3>

      {categories.map((cat, index) => (
        <div key={index} className="sidebar-category">
          <div
            className={`sidebar-category-title`}
            onClick={() => {
              toggleCategory(cat.category_name);
              navigate(`/termekek/${cat.category_name}`);
              onCategoryClick?.();
            }}
          >
            {cat.category_name}
          </div>

          {openCategory === cat.category_name && (
            <ul className="sidebar-subcategories">
              {cat.subcategories?.map((sub, subIndex) => (
                <li
                  key={subIndex}
                  
                  onClick={() => {
                    navigate(`/termekek/${cat.category_name}/${sub.name}`)
                    onCategoryClick?.();
                  }
                  }
                >
                  {sub.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </aside>
  );
};

export default SidebarCategories;